import '@babel/polyfill';
import Vue from "vue";
import Vuetify from 'vuetify';
import moment from 'moment';
import IBAN from 'iban';
import App from "./App";
import Routes from "./router";
import store from "./stores/store";
// import 'roboto-fontface/css/roboto/roboto-fontface.css'
// import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './stylus/main.styl';
import VueCookies from 'vue-cookies';



// import setClassToMaxWidth from "./stores/modules/DynamizeWidthClass";

Vue.prototype.moment = moment;
Vue.prototype.IBAN = IBAN;
Vue.prototype.pdfMake = pdfMake;

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  theme: {
    primary: '#002ea7',
    secondary: '#0074c6',
    accent: '#8c9eff',
    error: '#da291c',
    warning: '#ff8200',
    info: '#00a3ad',
    success: '#97d700',
    cta: '#da291c'
  },
  iconfont: 'md'
});

Vue.use(VueCookies);

var vgApp = new Vue({
  router: Routes,
  store,
  render: h => h(App)
}).$mount("#app");

/* Set the width definitions dynamically. That enables me to change them programmatically when needed. */
// setClassToMaxWidth('app-width',375);
// setClassToMaxWidth('dialog-width',350);
